import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";

import { isAndroid as android, isIOS as ios, osName as osname } from "react-device-detect";
import customProtocolCheck from "custom-protocol-check";
import "./AppLaunchPage.css";

const AppLaunchPage = () => {
  const [link, setLink] = useState("");
  const [openAppPopup, setOpenAppPopup] = useState(false);

  useEffect(() => {
    var uId = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).id : 0;
    var uToken = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";

    if (android) {
      setLink(
        "intent://virdio/?userId=" +
          uId +
          "&userToken=" +
          uToken +
          "#Intent;package=com.virdio.virdiohealth;scheme=open_app;end;"
      );
    } else if (ios) {
      setLink("https://deeplink.virdiohealth.com/auth/?userId=" + uId + "&token=" + uToken);
    } else if (osname === "Windows") {
      setLink("https://apps.microsoft.com/store/detail/virdiohealth/9MXKV20X29F7");
    } else {
      setLink("https://apps.apple.com/app/virdio-heath-for-desktop/id6448693919");
    }
  }, []);

  const checkOpenApp = () => {
    var uId = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).id : 0;
    var uToken = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";

    var openUrl =
      "virdiohealthapp://login?userId=" +
      uId +
      "&userToken=" +
      uToken +
      "#Intent;package=com.virdio.virdiohealthapp;scheme=open_app;end";
    if (android) {
      openUrl =
        "intent://virdio/?userId=" +
        uId +
        "&userToken=" +
        uToken +
        "#Intent;package=com.virdio.virdiohealth;scheme=open_app;end;";
    } else if (ios) {
      openUrl = "https://deeplink.virdiohealth.com/auth/?userId=" + uId + "&token=" + uToken;
    }

    customProtocolCheck(openUrl, 10000);
  };

  const handleDownloadApp = () => {
    window.open(link);
  };

  const handlePopup = () => {
    setOpenAppPopup(!openAppPopup);
  };

  return (
    <>
      <Header />
      <div className="applaunch_container" style={{marginBottom: '1rem'}}>
        <div className="top_part_applaunch_container">
          <div className="applaunch_top_part_picture"></div>
        </div>
        <div className="bottom_part_applaunch_container">
          <div className="applaunch_bottom_part_title">Open the Virdio Health App to see your recovery plan</div>
          <div className="applaunch_bottom_part_btn" onClick={handlePopup}>
            Open the App
          </div>
          <div className="applaunch_bottom_part_download">
            <span>Don’t have the application?</span>
            <span onClick={handleDownloadApp} className="applaunch_bottom_part_donthaveacc">
              {" "}
              Download here
            </span>
          </div>
        </div>
      </div>
      {openAppPopup && (
        <div className="dlt_wrapper">
          <div
            style={{ left: "50%", transform: "translateX(-50%)" }}
            className="dbl_place_on_page applaunch_popup_place_on_page"
          >
            <div className="dlt_surround applaunch_dlt_surround">
              <div className="applaunch_popup_title">
                <div className="dlt_title">Open the App</div>
                <div onClick={handlePopup} className="dlt_close_popup"></div>
              </div>

              <div className="applaunch_popup_description">
                <p>
                  By opening the application, you confirm your agreement to the <span>Terms of Service</span> and
                  <span> Privacy Policy</span>
                </p>
              </div>
              {android || ios ? (
                <a style={{ textDecoration: "none" }} href={link}>
                  <div style={{ textDecoration: "none" }} className="applaunch_popup_open">
                    Open
                  </div>
                </a>
              ) : (
                <div onClick={checkOpenApp} className="applaunch_popup_open">
                  Open
                </div>
              )}
              <div onClick={handlePopup} className="applaunch_popup_cancel">
                Cancel
              </div>
              <div style={{ fontSize: "14px", textAlign: "left" }} className="applaunch_bottom_part_download">
                <span style={{ color: "#8a8f9d" }}>Don’t have the application?</span>
                <span onClick={handleDownloadApp} className="applaunch_bottom_part_donthaveacc">
                  {" "}
                  Download here
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppLaunchPage;
